import { get } from '../request';

export interface LeaveRiskDto {
    userId: string;
    leaveProbability: number;
}

getLeaveRiskProbabilities.operation = 'READ';
getLeaveRiskProbabilities.idFrom = 'ARGS';
export function getLeaveRiskProbabilities(companyId: string) {
    return get<LeaveRiskDto[]>('/api/v2/company-analytics/leave-probability/' + companyId);
}
